<template>
  <div>
    <h2>Deal</h2>

    <div v-if="loading">Loading...</div>

    <b-alert
      v-for="(error, index) in errors"
      :key="index"
      show
      variant="danger"
      class="mt-3"
    >
      {{ error.msg }}
    </b-alert>

    <div v-if="deal._id">
      <table class="table">
        <tbody>
          <tr>
            <th>Deal Address</th>
            <td>
              <b-form-input
                v-model.trim="newAddress"
                @blur.native="geocode"
                @change="changed = true"
              ></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Deal Latitude</th>
            <td>
              <b-form-input v-model.trim="newDealLatitude"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Deal Longitude</th>
            <td>
              <b-form-input v-model.trim="newDealLongitude"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Title</th>
            <td>
              <b-form-input v-model.trim="newTitle"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Text</th>
            <td>
              <b-form-textarea
                v-model="newText"
                placeholder="Notification Text"
                :rows="10"
              >
              </b-form-textarea>
            </td>
          </tr>
          <tr>
            <th>Latitude</th>
            <td>
              <b-form-input v-model.trim="newLatitude"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Longitude</th>
            <td>
              <b-form-input v-model.trim="newLongitude"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Radius</th>
            <td>
              <b-form-input v-model.trim="newRadius"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Advertiser</th>
            <td>
              <b-form-input v-model.trim="newAdvertiser"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Categories</th>
            <td>
              <b-form-input v-model.trim="newCategories"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Duration</th>
            <td>
              <b-form-input v-model.trim="newDuration"></b-form-input>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-btn size="sm" @click="save()">Save</b-btn>
  </div>
</template>

<script>
import API from '@/api';
import Geocoder from '@/geocoder';

export default {
  name: 'DealDetail',
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      errors: [],
      newAddress: '',
      newDealLatitude: 0,
      newDealLongitude: 0,
      newTitle: '',
      newText: '',
      newLongitude: 0,
      newLatitude: 0,
      newRadius: 0,
      newAdvertiser: '',
      newCategories: '',
      newDuration: 0,
      loading: false,
      deal: {},
      changed: false,
      alertError: ''
    };
  },
  created() {
    this.loadDeal();
  },
  destroyed() {},
  methods: {
    loadDeal() {
      this.errors = [];
      this.loading = true;
      API.get(`admin/deal/${this.id}`).then(res => {
        this.loading = false;
        if (res.status === 'ok') {
          this.deal = res.data.deal;
          this.newAddress = this.deal.dealAddress;
          this.newDealLatitude = this.deal.dealLoc ? this.deal.dealLoc[1] : '';
          this.newDealLongitude = this.deal.dealLoc ? this.deal.dealLoc[0] : '';
          this.newTitle = this.deal.title;
          this.newText = this.deal.text;
          this.newLongitude = this.deal.loc ? this.deal.loc[0] : '';
          this.newLatitude = this.deal.loc ? this.deal.loc[1] : '';
          this.newRadius = this.deal.radius;
          this.newAdvertiser = this.deal.advertiser;
          this.newCategories = this.deal.categories;
          this.newDuration = this.deal.duration;
        } else {
          this.errors = this.errors.length
            ? this.errors.concat(res.errors)
            : res.errors;
        }
      });
    },
    acceptPaypalIdentifier() {
      this.errors = [];
    },
    geocode() {
      let $this = this;
      if (this.newAddress.length) {
        Geocoder.request(this.newAddress).then(res => {
          if (res.data) {
            res = res.data.result;
            $this.changed = false;
            this.newDealLongitude = res.geometry.location
              ? res.geometry.location.lng
              : '';
            this.newDealLatitude = res.geometry.location
              ? res.geometry.location.lat
              : '';
          }
        });
      }
    },
    save() {
      if (this.changed && this.newAddress.length) {
        setTimeout(() => {
          this.save();
        }, 0.3);
        return;
      }
      API.post('admin/deal/' + this.id, {
        dealLongitude: this.newDealLongitude,
        dealLatitude: this.newDealLatitude,
        dealAddress: this.newAddress,
        title: this.newTitle,
        text: this.newText,
        longitude: this.newLongitude,
        latitude: this.newLatitude,
        radius: this.newRadius,
        advertiser: this.newAdvertiser,
        categories: this.newCategories,
        duration: this.newDuration
      }).then(res => {
        this.submited = false;

        if (res.status === 'ok') {
          this.$router.go(-1);
        } else {
          this.errors = res.errors;
        }
      });
    }
  }
};
</script>

<style scoped></style>
